module.exports = __webpack_public_path__ + "static/img/Shoes PU products application straight_desktop.42245456.jpg";